import React from 'react';

// Theme-aware status colors using CSS variables
const statusStyles = {
  'Available': 'bg-[var(--tms-warning)]/15 text-[var(--tms-warning)] border border-[var(--tms-warning)]/30',
  'Booked': 'bg-[var(--tms-purple)]/15 text-[var(--tms-purple)] border border-[var(--tms-purple)]/30',
  'Dispatched': 'bg-teal-500/15 text-teal-600 border border-teal-500/30',
  'Setting Up': 'bg-cyan-500/15 text-cyan-700 border border-cyan-500/30',
  'Covered': 'bg-[var(--tms-primary)]/15 text-[var(--tms-primary)] border border-[var(--tms-primary)]/30',
  'RC Sent': 'bg-blue-500/15 text-blue-700 border border-blue-500/30',
  'Verified': 'bg-[var(--tms-success)]/15 text-[var(--tms-success)] border border-[var(--tms-success)]/30',
  'Rate Con Sent': 'bg-[var(--tms-purple)]/15 text-[var(--tms-purple)] border border-[var(--tms-purple)]/30',
  'At the Shipper': 'bg-[var(--tms-cyan)]/15 text-[var(--tms-cyan)] border border-[var(--tms-cyan)]/30',
  'In Transit': 'bg-[var(--tms-success)]/15 text-[var(--tms-success)] border border-[var(--tms-success)]/30',
  'In Transit MX': 'bg-emerald-500/15 text-emerald-600 border border-emerald-500/30',
  'At Border MX': 'bg-yellow-500/15 text-yellow-700 border border-yellow-500/30',
  'At Border US': 'bg-blue-500/15 text-blue-700 border border-blue-500/30',
  'In Transit US': 'bg-indigo-500/15 text-indigo-600 border border-indigo-500/30',
  'At Delivery': 'bg-teal-500/15 text-teal-600 border border-teal-500/30',
  'Delivered': 'bg-[var(--tms-success)]/15 text-[var(--tms-success)] border border-[var(--tms-success)]/30',
  'Released': 'bg-[var(--tms-text-muted)]/15 text-[var(--tms-text-secondary)] border border-[var(--tms-text-muted)]/30',
  'Change': 'bg-orange-500/15 text-orange-600 border border-orange-500/30',
  'Recovering': 'bg-[var(--tms-error)]/15 text-[var(--tms-error)] border border-[var(--tms-error)]/30',
};

const appointmentStyles = {
  'Needs Scheduling': 'bg-red-500',
  'Requested': 'bg-yellow-500',
  'Granted': 'bg-green-500',
  'Updated TMS': 'bg-transparent border-2 border-gray-400',
};

export const StatusBadge = ({ status, testId }) => {
  const styleClass = statusStyles[status] || 'bg-[var(--tms-hover)] text-[var(--tms-text-secondary)] border border-[var(--tms-border)]';
  return (
    <span 
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${styleClass}`} 
      data-testid={testId}
    >
      {status}
    </span>
  );
};

// Solid Carrier Assignment colors — same palette as the workspace status bars (.lw-statusbar.*)
const carrierStatusStyles = {
  'Available': { background: '#b39ddb', color: '#2c1a4d' },
  'Setting Up': { background: '#7fdbda', color: '#073d3c' },
  'Covered': { background: '#b8e6c9', color: '#0c4a25' },
  'RC Sent': { background: '#66a3ff', color: '#06254d' },
  'Verified': { background: '#ffffff', color: '#14161c', border: '1px solid #c9ced9' },
  'Verify': { background: '#ffffff', color: '#14161c', border: '1px solid #c9ced9' },
  'Change': { background: '#f77e17', color: '#ffffff' },
  'Recovering': { background: '#F8191B', color: '#ffffff' },
};

export const CarrierStatusBadge = ({ status, testId }) => (
  <span
    className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap"
    style={carrierStatusStyles[status] || { background: '#eef0f6', color: '#14161c' }}
    data-testid={testId}
  >
    {status}
  </span>
);

export const AppointmentBadge = ({ status, testId }) => {
  const bgColor = appointmentStyles[status] || 'bg-[var(--tms-text-muted)]';
  return (
    <span 
      className={`inline-block w-3 h-3 rounded-full ${bgColor} shadow-sm`} 
      title={status}
      data-testid={testId}
    />
  );
};
